/**
 * Utility function to detect if the device is likely a mobile device, e.g. if
 * it has a camera that will open for camera-specific <input> elements.
 *
 * This function uses pointer type detection and user agent detection, so better
 * corresponds to a true device check rather than screen width. Depending on what
 * you're trying to detect, there may be better options:
 * - To adjust styling to mobile screen sizes, use media queries.
 * - To programmatically adjust the render behavior for mobile screen sizes, use
 *   useIsPhoneWidth.
 * - To detect mobile-specific features, try to find a DOM API to detect if the feature
 *   is available.
 * - If no DOM API is available, use this function as a good guess as to whether this
 *   is a mobile device.
 */
export default function isLikelyMobileCapabilities(): boolean {
  return window.matchMedia('(pointer:coarse)').matches || /Mobi|Android/i.test(navigator.userAgent);
}
